var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class LogoutSubscription {
    constructor(player, gateway, tokenValidator) {
        this.onLogout = () => __awaiter(this, void 0, void 0, function* () {
            yield this.gateway.logout();
        });
        this.onSecondStepLoginFailed = () => __awaiter(this, void 0, void 0, function* () {
            yield this.gateway.forceLoadAnonymousToken();
        });
        this.onDataUpdated = () => __awaiter(this, void 0, void 0, function* () {
            const currentToken = yield this.gateway.getToken();
            if (this.tokenValidator.isAnonymous(currentToken)) {
                this.player.showSessionExpired();
                this.player.logout();
            }
        });
        this.player = player;
        this.gateway = gateway;
        this.tokenValidator = tokenValidator;
    }
    subscribe() {
        this.player.onLogout["LogoutSubscription"] = this.onLogout;
        this.player.onNotLoggedIn["LogoutSubscription"] = this.onLogout;
        this.player.onSecondStepLoginFailed["LogoutSubscription"] = this.onSecondStepLoginFailed;
        this.player.onSessionKeepAlive["LogoutSubscription"] = this.onDataUpdated;
    }
}
//# sourceMappingURL=LogoutSubscription.js.map